import { DataItem } from 'scrivito'

import { formatDateKey } from '../../utils/dateUtils'
import { ensureString } from '@/utils/ensureString'

export interface UtilizationAggregate {
  dailyUtilization: Map<string, number>
  dailyAbsent: Map<string, boolean>
  totalWorkingTime: number
  totalUtilizationWeighted: number
}

const readUtilization = (record: DataItem) => ({
  date: formatDateKey(new Date(ensureString(record.get('date')))),
  workingTime: Number(record.get('workingTime')) || 0,
  utilizationTime: Number(record.get('utilizationTime')) || 0,
  utilizationFactor: Number(record.get('utilizationFactor')) || 0,
  isAbsent: record.get('isAbsent') as boolean,
})

export const accumulateUtilization = (
  utilizationRecords: DataItem[],
): UtilizationAggregate =>
  utilizationRecords.reduce<UtilizationAggregate>(
    (acc, record) => {
      const u = readUtilization(record)
      acc.dailyAbsent.set(u.date, u.isAbsent)

      if (!u.isAbsent) {
        acc.dailyUtilization.set(
          u.date,
          Math.round(
            (u.utilizationTime * u.utilizationFactor * 100) / u.workingTime,
          ),
        )
        acc.totalUtilizationWeighted += u.utilizationTime * u.utilizationFactor
        acc.totalWorkingTime += u.workingTime
      }
      return acc
    },
    {
      dailyUtilization: new Map(),
      dailyAbsent: new Map(),
      totalWorkingTime: 0,
      totalUtilizationWeighted: 0,
    },
  )
